import { Injectable } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { filter } from "rxjs";

// https://angular.dev/ecosystem/service-workers/communications

@Injectable({providedIn: 'root'})
export class PromptUpdateService {
  constructor(swUpdate: SwUpdate) {
    swUpdate.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe((evt) => {
        // Only prompt the user if the app is running as an installed PWA.
        if (this.isInstalledPWA() && this.promptUser(evt)) {
          // Reload the page to update to the latest version.
          document.location.reload();
        }
      });
  }

  private promptUser(evt: VersionReadyEvent): boolean {
    return window.confirm(
      `A new version of the app is available!\n\n` +
      `Would you like to update now?`
    );
  }

  private isInstalledPWA(): boolean {
    // Check if the display mode is standalone (supported by most modern browsers)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    // iOS Safari sets window.navigator.standalone to true when running as an installed PWA.
    const isStandaloneIOS = (window.navigator as any).standalone === true;
    return isStandalone || isStandaloneIOS;
  }
}
